import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCommission(value: number | null, type?: string | null): string {
  if (value == null) return '—';
  if (type === 'fixed') return `R$ ${value.toFixed(2).replace('.', ',')}`;
  return `${value}%`;
}

export function formatDonation(value: number | null, type?: string | null): string {
  if (value == null) return '';
  if (type === 'fixed') return `R$ ${value.toFixed(2).replace('.', ',')}`;
  return `${value}%`;
}

export function appendClickRef(url: string, network: string | null, clickId: string): string {
  if (!network || !clickId) return url;

  if (network === 'awin') {
    try {
      const parsed = new URL(url);
      if (parsed.searchParams.has('clickref')) return url;
      parsed.searchParams.append('clickref', clickId);
      return parsed.toString();
    } catch {
      return url;
    }
  }

  // CJ (Commission Junction): parâmetro oficial `sid`, máx 64 chars.
  // Doc: https://developers.cj.com/docs/publisher-site-tracking/publisher-parameter
  // Inserido como PRIMEIRO parâmetro para não interferir no `url=` encodado do deeplink.
  if (network === 'cj') {
    if (/[?&]sid=/i.test(url)) return url;
    const sid = encodeURIComponent(clickId.slice(0, 64));
    const qIndex = url.indexOf('?');
    if (qIndex === -1) return `${url}?sid=${sid}`;
    return `${url.slice(0, qIndex + 1)}sid=${sid}&${url.slice(qIndex + 1)}`;
  }

  try {
    const urlObj = new URL(url);
    if (network === 'cityads' || network === 'sovaunion') {
      urlObj.searchParams.set('sa', clickId);
    } else if (network === 'admitad') {
      urlObj.searchParams.set('subid', clickId);
    } else if (network === 'afilio') {
      urlObj.searchParams.set('xtra1', clickId);
    } else if (network === 'lomadee') {
      urlObj.searchParams.set('mdasc', clickId);
    } else if (network === 'rakuten') {
      urlObj.searchParams.set('u1', clickId);
    } else if (network === 'igoal') {
      urlObj.searchParams.set('aff_sub', clickId);
    }
    return urlObj.toString();
  } catch {
    // Fallback if URL parsing fails
    const sep = url.includes('?') ? '&' : '?';
    if (network === 'cityads' || network === 'sovaunion') return url + `${sep}sa=${clickId}`;
    if (network === 'admitad') return url + `${sep}subid=${clickId}`;
    if (network === 'afilio') return url + `${sep}xtra1=${clickId}`;
    if (network === 'lomadee') return url + `${sep}mdasc=${clickId}`;
    if (network === 'rakuten') return url + `${sep}u1=${clickId}`;
    if (network === 'igoal') return url + `${sep}aff_sub=${clickId}`;
    return url;
  }
}

export const MARKETPLACE_BRAND_IDS = [
  "94342c8b-7e3c-4334-9b8d-ae9ec0f6e82e", // AliExpress (Admitad)
  "173145fb-cc82-4b55-b7ba-eb39fa6dd2b8", // AliExpress (Awin antigo)
  "e514d9ee-8357-4090-91d8-8dda873707f1", // Aliexpress (Awin/WordPress)
  "d2e73dd4-5804-4d32-9a74-ddfeba959f88", // Aliexpress BR & LATAM (Awin)
  "b1922101-2e26-4c50-bb31-19bc666ebbc4", // Shopee
  "bb2adc12-39c6-48c6-9f5c-57d49e37fffc", // Temu
];
